module.exports = __webpack_public_path__ + "static/img/16.cd0adf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/16.png
// module id = 5A15
// module chunks = 0